/* eslint-disable */

export default {
  init() {
    function getTraviusWidgetKey() {
      var scriptTag = document.getElementById('travius-widget-cart-script');

      if (!scriptTag || !scriptTag.src) {
        return null;
      }

      var match = scriptTag.src.match(/[?&]key=([^&]+)/);
      return match ? decodeURIComponent(match[1]) : null;
    }

    function buildTraviusCartSrc(checkoutUrl) {
      var key = getTraviusWidgetKey();

      if (!key) {
        return '';
      }

      var src = 'https://widget.ranuaresort.com/cart-items.aspx?view=cart&key=' + encodeURIComponent(key);

      if (checkoutUrl) {
        src += '&checkout=' + encodeURIComponent(checkoutUrl);
      }

      return src;
    }

    $('.travius-cart-iframe').each(function () {
      var $iframe = $(this);
      var $amount = $iframe.closest('.travius-cart-amount');
      var checkoutUrl = $iframe.data('checkout');

      if (!$amount.length) {
        return;
      }

      var revealTimeout;

      function revealCartAmount() {
        window.clearTimeout(revealTimeout);
        revealTimeout = window.setTimeout(function () {
          $amount.addClass('--loaded');
        }, 600);
      }

      $iframe.on('load', revealCartAmount);

      // Mobile cart src is set by travius-widget-cart.js on window load.
      if ($iframe.attr('id') === 'travius-cart-desktop') {
        var cartSrc = buildTraviusCartSrc(checkoutUrl);

        if (cartSrc) {
          $iframe.attr('src', cartSrc);
        }
      }

      window.setTimeout(function () {
        if (!$amount.hasClass('--loaded') && $iframe.attr('src')) {
          revealCartAmount();
        }
      }, 3000);
    });

    // Update local clock client-side so cached pages always show the current time.
    var $clock = $('.js-local-time');
    if ($clock.length) {
      var timezone = $clock.data('timezone') || 'UTC';
      var formatter = new Intl.DateTimeFormat([], {
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
        timeZone: timezone,
      });
      function updateClock() {
        $clock.text(formatter.format(new Date()));
      }
      updateClock();
      // Re-tick at the start of every new minute.
      var now = new Date();
      var msUntilNextMinute = (60 - now.getSeconds()) * 1000 - now.getMilliseconds();
      setTimeout(function () {
        updateClock();
        setInterval(updateClock, 60000);
      }, msUntilNextMinute);
    }

    $(window).load(function() { 
      if($('.current-menu-parent').length) {
        var parentElement = $('.current-menu-parent');
        parentElement.addClass('expanded');
        parentElement.find('.sub-menu').slideToggle( "fast", function() {
          // Animation complete.
        });
      }
    });

    // JavaScript to be fired on all pages
    $('#show-comments-btn').on('click', function() {
      $('li.comment').show();
      $(this).hide();
    });


    $('.lunch-tabs .lunch-tab').on('click', function() {
      let id = $(this).data('id');
      let type = $(this).data('type');

      $('#lunch-tabs-' + id + ' .lunch-tab').removeClass('--active');
      $(this).addClass('--active');

      if( type == 'lounas' ) {
        $('#content-lounas-' + id).addClass('--active');
        $('#content-aamiainen-' + id).removeClass('--active');
      }
      else if( type == 'aamiainen' ) {
        $('#content-lounas-' + id).removeClass('--active');
        $('#content-aamiainen-' + id).addClass('--active');
      }
    });

    /**
     * Majoitushaku
     */
    $('.search-majoitukset .tt-number-input').on('change', function() {
      let baseurl = $('#katso-majoitukset-link').data('majoitukset-url');
      let peopleamount = $(this).val();
      let newurl = baseurl + '?people=' + peopleamount;
      $('#katso-majoitukset-link').attr( 'href', newurl );
    });

    /**
     * Numero input
     */
     $('.tt-number-input-container').each(function() {
        var spinner = $(this),
          input = spinner.find('input[type="number"]'),
          btnUp = spinner.find('.quantity-up'),
          btnDown = spinner.find('.quantity-down'),
          min = input.attr('min'),
          max = input.attr('max');

        btnUp.on('click', function() {
          var oldValue = parseFloat(input.val());
          var newValue = (oldValue >= max) ? oldValue : oldValue + 1;
          spinner.find("input").val(newValue);
          spinner.find("input").trigger("change");
        });

        btnDown.on('click', function() {
          var oldValue = parseFloat(input.val());
          var newValue = (oldValue <= min) ? oldValue : oldValue - 1;
          spinner.find("input").val(newValue);
          spinner.find("input").trigger("change");
        });
     });

     $('.video-play-button').on('click', function() {
      $(this).addClass('hidden');
      $('.video-pause-button').removeClass('hidden');
      let id = $(this).data('id');
      let video = $('.video-hero[data-id="' + id + '"]');
      $(video).trigger('play');
     });

     $('.video-pause-button').on('click', function() {
      $(this).addClass('hidden');
      $('.video-play-button').removeClass('hidden');
      let id = $(this).data('id');
      let video = $('.video-hero[data-id="' + id + '"]');
      $(video).trigger('pause');
     });

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};


/* eslint-enable */


// WEBPACK FOOTER //
// ./scripts/routes/common.js